{
  "title": "Cloudkill",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level conjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "You create a 20-foot-radius sphere of poisonous, yellow-green fog centered on a point you choose within range. The fog spreads around corners. It lasts for the duration or until strong wind disperses the fog, ending the spell. Its area is heavily obscured.",
    "When a creature enters the spell’s area for the first time on a turn or starts its turn there, that creature must make a Constitution saving throw. The creature takes 5d8 poison damage on a failed save, or half as much damage on a successful one. Creatures are affected even if they hold their breath or don’t need to breathe.",
    "The fog moves 10 feet away from you at the start of each of your turns, rolling along the surface of the ground. The vapors, being heavier than air, sink to the lowest level of the land, even pouring down openings.",
    "At Higher Levels. When you cast this spell using a spell slot of 6th level or higher, the damage increases by 1d8 for each slot level above 5th."
  ],
  "spellLists": ["sorcerer", "wizard"]
}
